/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchSurveyMarkGeometryDto } from '../../models/search-survey-mark-geometry-dto';

export interface SearchForSurveyMarkGeometryByPfiList$Params {
  pfi: Array<string>;
}

export function searchForSurveyMarkGeometryByPfiList(
  http: HttpClient,
  rootUrl: string,
  params: SearchForSurveyMarkGeometryByPfiList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchSurveyMarkGeometryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForSurveyMarkGeometryByPfiList.PATH,
    'get',
  );
  if (params) {
    rb.query('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchSurveyMarkGeometryDto>;
      }),
    );
}

searchForSurveyMarkGeometryByPfiList.PATH = '/search/survey-mark/geometry';
